import {hideBodyScroll, showBodyScroll} from "../PageHelpers";

const overlayClass = 'profileAvatarShareOverlay';
const qrCache = {};

function getProfileUrl(){
    return window.location.href.split('#')[0];
}

function copyProfileUrl(url){
    if(navigator.clipboard && navigator.clipboard.writeText){
        return navigator.clipboard.writeText(url);
    }

    let input = $('<input type="text" readonly>').val(url).appendTo('body');
    input[0].select();
    document.execCommand('copy');
    input.remove();

    return Promise.resolve();
}

function openShareDialog(url, title, imageUrl){
    let shareItem = $('<button type="button" class="shareItem"></button>')
        .data('url', url)
        .data('title', title || '')
        .data('image', imageUrl || '')
        .hide()
        .appendTo('body');

    shareItem.trigger('click');
    shareItem.remove();
}

function parseResponse(response){
    return typeof ParseResp === 'function' ? ParseResp(response) : response;
}

function closeProfileAvatarShare(){
    $('.' + overlayClass).removeClass('active');

    setTimeout(function(){
        $('.' + overlayClass).remove();

        if($('.slidemenu.active').length === 0){
            showBodyScroll();
        }
    }, 200);
}

function closeQrPanel(overlay){
    overlay.find('.profileAvatarShareMedia').removeClass('qr-visible');
    overlay.find('.profileAvatarShareQrView').removeClass('active');
}

function renderQrIcon(){
    return '<span class="profileAvatarShareQrIcon">' +
        '<span></span><span></span><span></span><span></span>' +
    '</span>';
}

function renderQrPanel(){
    return $('<div class="profileAvatarShareQrView">' +
        '<button type="button" class="profileAvatarShareQrClose" aria-label="Close"><i class="icon-cross"></i></button>' +
        '<div class="profileAvatarShareQrBody"><div class="loader loader-sm"></div></div>' +
    '</div>');
}

function renderOverlay(avatarUrl, username){
    avatarUrl = avatarUrl || '';

    let overlay = $('<div class="' + overlayClass + '"></div>');
    let close = $('<button type="button" class="profileAvatarShareClose" aria-label="Close"><i class="icon-cross"></i></button>');
    let content = $('<div class="profileAvatarShareContent"></div>');
    let media = $('<div class="profileAvatarShareMedia"></div>');
    let image = $('<img class="profileAvatarShareImage" alt="">').attr('src', avatarUrl).attr('alt', username);
    let panel = $('<div class="profileAvatarSharePanel"></div>');

    overlay[0].style.setProperty('--profile-avatar-share-bg', 'url("' + avatarUrl.replace(/"/g, '\\"') + '")');
    panel.append(renderAction('share', '<i class="icon-share"></i>', 'Share<br>profile'));
    panel.append(renderAction('copy', '<i class="icon-link"></i>', 'Copy<br>link'));
    panel.append(renderAction('qr', renderQrIcon(), 'QR code'));

    media.append(image);
    content.append(media).append(panel);
    overlay.append(close).append(content);

    return overlay;
}

function renderAction(action, icon, text){
    return $('<button type="button" class="profileAvatarShareAction" data-action="' + action + '">' +
        '<span class="profileAvatarShareIcon">' + icon + '</span>' +
        '<span>' + text + '</span>' +
    '</button>');
}

function openProfileAvatarShare(avatar){
    let img = avatar.find('img.user_avatar').first();
    let profileUrl = getProfileUrl();
    let avatarUrl = avatar.data('avatarOrg') || img.attr('src') || '';
    let overlay = renderOverlay(avatarUrl, img.attr('alt') || '');

    $('.' + overlayClass).remove();
    $('body').append(overlay);
    hideBodyScroll();

    requestAnimationFrame(function(){
        overlay.addClass('active');
    });

    overlay.on('click', function(e){
        if(e.target === overlay[0]){
            closeProfileAvatarShare();
        }
    });

    overlay.find('.profileAvatarShareClose').on('click', closeProfileAvatarShare);
    overlay.find('[data-action="share"]').on('click', function(){
        closeProfileAvatarShare();
        openShareDialog(profileUrl, img.attr('alt') || '', avatarUrl);
    });
    overlay.find('[data-action="copy"]').on('click', function(){
        copyProfileUrl(profileUrl).then(function(){
            notice('Copied', {color: 'green'});
        });
    });
    overlay.find('[data-action="qr"]').on('click', function(){
        showQrPanel(overlay, profileUrl);
    });
}

function showQrPanel(overlay, profileUrl){
    let qrPanel = overlay.find('.profileAvatarShareQrView');
    let media = overlay.find('.profileAvatarShareMedia');

    if(qrPanel.length > 0){
        media.addClass('qr-visible');
        qrPanel.addClass('active');
        return;
    }

    qrPanel = renderQrPanel();
    media.append(qrPanel);
    media.addClass('qr-visible');

    requestAnimationFrame(function(){
        qrPanel.addClass('active');
    });

    qrPanel.on('click', function(e){
        e.stopPropagation();
    });

    qrPanel.find('.profileAvatarShareQrClose').on('click', function(e){
        e.preventDefault();
        e.stopPropagation();
        closeQrPanel(overlay);
    });

    if(qrCache[profileUrl]){
        qrPanel.find('.profileAvatarShareQrBody').html(qrCache[profileUrl]);
        return;
    }

    $.ajax({
        url: '/ajax/profile.qr',
        method: 'GET',
        dataType: 'JSON',
        data: {url: profileUrl}
    }).done(function(response){
        let data = parseResponse(response);

        if(data && data.data && data.data.svg){
            qrCache[profileUrl] = data.data.svg;
            qrPanel.find('.profileAvatarShareQrBody').html(data.data.svg);
        }else{
            qrPanel.find('.profileAvatarShareQrBody').html('<span class="profileAvatarShareQrError">QR code unavailable</span>');
        }
    }).fail(function(){
        qrPanel.find('.profileAvatarShareQrBody').html('<span class="profileAvatarShareQrError">QR code unavailable</span>');
    });
}

function profileAvatarShareInit(){
    $(document).off('click.profileAvatarShare', '[data-profile-avatar-share]').on('click.profileAvatarShare', '[data-profile-avatar-share]', function(e){
        if($(e.target).closest('.foto_edit_box').length > 0){
            return;
        }

        e.preventDefault();
        e.stopPropagation();
        openProfileAvatarShare($(this));
    });

    $(document).off('keydown.profileAvatarShare').on('keydown.profileAvatarShare', function(e){
        if(e.key === 'Escape' && $('.' + overlayClass).length > 0){
            closeProfileAvatarShare();
        }
    });
}

if(document.readyState === 'loading'){
    window.addEventListener('load', profileAvatarShareInit);
}else{
    profileAvatarShareInit();
}
